import * as React from 'react'

function MenuIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={15.998} height={14} viewBox="0 0 15.998 14" {...props}>
      <path d="M19996.029 23821v-2H20008v2zm1.973-6v-2h10v2zm-6-6v-2h16v2z" transform="translate(-19992 -23807)" />
    </svg>
  )
}

export default MenuIcon
